// Small, dependency-free rules for the outbound path, kept out of sb.js so they
// can be tested without pulling in the whole app.

// counts() is synchronous. running() returns a Promise, so the old
// `queue.running() == 0` test was never true: an already-idle queue then waited
// for an 'idle' event that only fires after some *later* job, which at handover
// meant the turn-passing write waited on an unrelated network event.
export function queueIsIdle(queue){
    let c = queue.counts();
    return c.RECEIVED + c.QUEUED + c.RUNNING + c.EXECUTING === 0;
}

// Game writes opt out of PocketBase's auto-cancellation (requestKey: null) — the
// queue already orders them — so an abort here is a timeout or a page teardown.
// status 0 alone is NOT a cancellation: it is what a plain network failure
// (offline, connection reset) looks like, and must be retried.
export function isAutoCancelled(error){
    if(!error) return false;
    return !!error.isAbort;
}
